// v2.19.22f-1 — Wrapper fetch avec injection auto Bearer + 401 silent logout.
// À utiliser pour les nouvelles routes user-authed. Les call sites existants
// continuent d'utiliser fetch() natif (zéro regression).

const TOKEN_KEY = "civ_user_token";
const PROFILE_KEY = "civ_user_profile";
const EVENT_NAME = "civ:auth-changed";

export async function apiFetch(url, opts = {}) {
  const token = localStorage.getItem(TOKEN_KEY);
  const headers = { ...(opts.headers || {}) };
  if (token && !headers.Authorization && !headers.authorization) {
    headers.Authorization = `Bearer ${token}`;
  }
  const res = await fetch(url, { ...opts, headers });
  if (res.status === 401 && token) {
    // Token expiré / révoqué → logout silencieux + notify React tree.
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(PROFILE_KEY);
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: null }));
  }
  return res;
}

export function getAuthToken() {
  return localStorage.getItem(TOKEN_KEY);
}
